const HotTable = !process.client ? null : require('@handsontable/vue').HotTable
export default HotTable